const module = {
  config: {
    name: "aktifitas",
    svg: "../static/img/icon/menu/survey.svg",
    desc: "Berisi modul aktifitas perpustakaan.",
    layout: true,
  },
  routes: [
    // Kehadiran
    {
      name: "Scan Kehadiran",
      icon: "ri-qr-code-fill",
      path: "/scan-kehadiran",
      component: () => import("./scan/kehadiran.vue"),
      separator: "Scan",
    },
    // Peminjaman Buku
    {
      name: "Scan Peminjaman Buku",
      icon: "ri-qr-code-fill",
      path: "/scan-peminjaman-buku",
      component: () => import("./scan/peminjaman-buku.vue"),
      separator: "Scan",
    },
    // Pengembalian Buku
    {
      name: "Scan Pengembalian Buku",
      icon: "ri-qr-code-fill",
      path: "/scan-pengembalian-buku",
      component: () => import("./scan/pengembalian-buku.vue"),
      separator: "Scan",
    },
    {
      name: "Kehadiran",
      icon: "ri-door-open-fill",
      path: "/kehadiran",
      component: () => import("./attendance.vue"),
      separator: "Attendance",
    },
    {
      name: "Peminjaman Buku",
      icon: "ri-book-read-fill",
      path: "/peminjaman-buku",
      component: () => import("./borrow-book/index.vue"),
      separator: "Borrowing",
    },
    {
      name: "Denda",
      icon: "ri-alert-fill",
      path: "/denda-peminjaman-buku",
      component: () => import("./borrow-book/list-penalty.vue"),
      separator: "Borrowing",
    },
  ],
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/activities/_index.js